import AOS from 'aos';
import 'aos/dist/aos.css';

export const initAOS = () => {
    setTimeout(() => {
        AOS.init({
            once: true,
        });
        // refresh after DOM ready or jQuery manipulations
        window.addEventListener('load', () => {
            AOS.refresh();
        });
    }, 100);
};